import { render } from "./MediaManager.vue?vue&type=template&id=12101630"
import script from "./MediaManager.vue?vue&type=script&lang=js"
export * from "./MediaManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__